/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} File_Export_Dialogue_List_TitleInputs */



/**
* | output |
* | --- |
* | "Dialogue List" |
*
* @param {File_Export_Dialogue_List_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const file_export_dialogue_list_title = /** @type {((inputs?: File_Export_Dialogue_List_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<File_Export_Dialogue_List_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Liste des dialogues")
	if (locale === "de") return /** @type {LocalizedString} */ ("Dialogliste")
	if (locale === "it") return /** @type {LocalizedString} */ ("Elenco dialoghi")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Список диалогов")
	if (locale === "es") return /** @type {LocalizedString} */ ("Lista de diálogos")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("对话列表")
	if (locale === "ja") return /** @type {LocalizedString} */ ("会話リスト")
	if (locale === "hi") return /** @type {LocalizedString} */ ("संवाद सूची")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Lista de diálogos")
	return /** @type {LocalizedString} */ ("Dialogue List")
});